import {isMobile} from '#core/utils/context-utils.js';
import {icon} from '#core/utils/style-utils.js';

import {generateOddsButton} from '#core/application/modules/tiles/odds-button/index.js';
import {generateSkeletonPart} from '#core/application/modules/tiles/skeleton-part/index.js';
import {generateTertiaryLink} from '#core/application/modules/tiles/link/index.js';

export function competitionsTableFactory(PALETTE) {
    const FIXTURE_TOGGLE = {
        button: generateTertiaryLink(PALETTE.TABLE_TOGGLE_FIXTURES_BUTTON),
        rotation: {
            image: {
                style: {
                    fill: PALETTE.TABLE_TOGGLE_FIXTURES_BUTTON.TERTIARY_LINK_ICON_COLOR,
                    minHeight: '8px',
                },
            },
        },
    };

    return {
        EventTable: {
            emptyText: {
                style: {
                    ...PALETTE.TABLE_NO_DATA_TEXT,
                },
            },
            groupLabel: {
                style: {
                    ...PALETTE.TABLE_GROUP_TITLE_TEXT,
                },
            },
            headerRow: {
                headerText: {
                    style: {
                        ...(isMobile() ? PALETTE.MOBILE_TABLE_HEADER_TEXT : PALETTE.TABLE_HEADER_TEXT),
                    },
                },
            },
            dataRow: {
                cell: {
                    countryOrSportIcon: {
                        sportIcon: {
                            icon: icon(PALETTE.TABLE_TEAM_SPORT_ICON_COLOR),
                        },
                    },
                    countryNameText: {
                        style: {
                            ...PALETTE.TABLE_TEAM_NAME_TEXT,
                        },
                    },
                    rankBadge: {
                        style: {
                            minWidth: '28px',
                            borderRadius: PALETTE.TABLE_RANK_BADGE_BORDER_RADIUS,
                        },
                    },
                    rankBadgeText: {
                        style: {
                            ...PALETTE.TABLE_RANK_BADGE_TEXT,
                        },
                    },
                    rankText: {
                        style: {
                            ...PALETTE.TABLE_RANK_TEXT,
                        },
                    },
                    genericText: {
                        style: {
                            textAlign: 'center',
                            ...PALETTE.TABLE_DATA_TEXT,
                        },
                    },
                    unavailableOddsText: {
                        style: {
                            ...PALETTE.TABLE_ODDS_NOT_AVAILABLE_TEXT,
                        },
                    },
                    selectionButton: generateOddsButton(PALETTE.TABLE_ODDS_BUTTON),
                },
            },
            toggleButton: FIXTURE_TOGGLE.button,
            rotation: FIXTURE_TOGGLE.rotation,
        },
        EventTableFixtures: {
            fixturesToggleButton: FIXTURE_TOGGLE.button,
            fixturesRotation: FIXTURE_TOGGLE.rotation,
            fixtureRow: {
                container: {
                    style: {
                        borderColor: PALETTE.TABLE_FIXTURE_ROW_DIVIDER_COLOR,
                    },
                },
                countryOrSportIcon: {
                    sportIcon: {
                        icon: icon(PALETTE.TABLE_TEAM_SPORT_ICON_COLOR),
                    },
                },
                homeTeamName: {
                    style: {
                        ...PALETTE.TABLE_TEAM_NAME_TEXT,
                    },
                },
                awayTeamName: {
                    style: {
                        ...PALETTE.TABLE_TEAM_NAME_TEXT,
                    },
                },
                scoreBlock: {
                    itemSpacing: '4px',
                    style: {
                        flexDirection: 'row',
                    },
                },
                scoreText: {
                    style: {
                        ...PALETTE.TABLE_FIXTURE_SCORE_TEXT,
                    },
                },
                separator: {
                    style: {
                        ...PALETTE.TABLE_FIXTURE_SCORE_SEPARATOR_TEXT,
                    },
                },
                resultLabel: {
                    style: {
                        ...PALETTE.TABLE_FIXTURE_RESULT_LABEL_TEXT,
                    },
                },
                dateTimeText: {
                    style: {
                        ...PALETTE.TABLE_FIXTURE_DATE_TIME_TEXT,
                    },
                },
                selectionButton: generateOddsButton(PALETTE.TABLE_ODDS_BUTTON),
            },
        },
        EventTableSkeleton: {
            primaryHeaderPlaceholder: generateSkeletonPart(PALETTE.TABLE_SKELETON_PART),
            headerPlaceholder: generateSkeletonPart(PALETTE.TABLE_SKELETON_PART),
            valuePlaceholder: generateSkeletonPart(PALETTE.TABLE_SKELETON_PART),
            countryIconPlaceholder: generateSkeletonPart(PALETTE.TABLE_SKELETON_PART),
            countryNamePlaceholder: generateSkeletonPart(PALETTE.TABLE_SKELETON_PART),
        },
    };
}
